import { getConfig } from '~/services/config';
import axiosInstance from '../axios';
import { APIResponse } from '../types';
import { ClassModel } from '../types/schedule';
import {
  ClassAccessGroup,
  ClassAccessGroupItem,
  CreateClassAccessGroupRequest,
  UpdateClassAccessGroupRequest,
} from '../types/session-access';

export function getClassAccessGroups(locationId: number) {
  const config = getConfig();

  return axiosInstance
    .get<APIResponse<ClassAccessGroup[]>>(`${config.domains.plans}/classes/locations/${locationId}/class_access_groups`)
    .then(({ data }) => data?.data)
    .catch((error) => {
      console.error('Error fetching class access groups:', error);
      throw error;
    });
}

export function getClassAccessGroup(locationId: number, id: number | undefined) {
  const config = getConfig();

  return axiosInstance
    .get<
      APIResponse<ClassAccessGroupItem>
    >(`${config.domains.plans}/classes/locations/${locationId}/class_access_groups/${id}`)
    .then(({ data }) => data?.data);
}

export function getAllClasses(locationId: number) {
  const config = getConfig();

  return axiosInstance
    .get<APIResponse<ClassModel[]>>(`${config.domains.plans}/classes/locations/${locationId}/classes`)
    .then(({ data }) => data?.data);
}

export function createClassAccessGroup(locationId: number, data: CreateClassAccessGroupRequest) {
  const config = getConfig();

  return axiosInstance
    .post<
      APIResponse<ClassAccessGroup>
    >(`${config.domains.plans}/classes/locations/${locationId}/class_access_groups`, data)
    .then(({ data }) => data);
}

export function updateClassAccessGroup(locationId: number, id: number, data: UpdateClassAccessGroupRequest) {
  const config = getConfig();

  return axiosInstance
    .put<
      APIResponse<ClassAccessGroup>
    >(`${config.domains.plans}/classes/locations/${locationId}/class_access_groups/${id}`, data)
    .then(({ data }) => data);
}
